var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 13.3 17",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8117 5.76007H11.6434C12.5582 5.76007 13.3067 6.4595 13.3067 7.31436V15.0858C13.3067 15.9406 12.5582 16.6401 11.6434 16.6401H1.66334C0.748502 16.6401 0 15.9406 0 15.0858V7.31436C0 6.4595 0.748502 5.76007 1.66334 5.76007H2.49501V4.20578C2.49501 2.06087 4.35794 0.320068 6.65335 0.320068C8.94876 0.320068 10.8117 2.06087 10.8117 4.20578V5.76007ZM4.15867 4.20587V5.76016H9.14868V4.20587C9.14868 2.91582 8.03425 1.87444 6.65368 1.87444C5.2731 1.87444 4.15867 2.91582 4.15867 4.20587Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5e3fbe89766a477e70ad1c0e5c1fbb5e.svg";
export { ForwardRef as ReactComponent };